import { saveAs } from "file-saver";
import apiClient from "Configuration/apiClient";

const parseDatePayload = (dateStr) => {
  const [y, m, d] = dateStr.split("-").map(Number);
  return { date: d, month: m, year: y };
};

const RED_FILL    = { type: "pattern", pattern: "solid", fgColor: { argb: "FFC72127" } };
const ORANGE_FILL = { type: "pattern", pattern: "solid", fgColor: { argb: "FFCC5500" } };
const AMBER_FILL  = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFD000" } };
const WHITE_FONT_BOLD = { bold: true, color: { argb: "FFFFFFFF" }, size: 10 };
const BLACK_FONT_BOLD = { bold: true, color: { argb: "FF000000" }, size: 10 };
const CENTER_WRAP = { horizontal: "center", vertical: "middle", wrapText: true };
const THIN_BORDER = {
  top:    { style: "thin" },
  bottom: { style: "thin" },
  left:   { style: "thin" },
  right:  { style: "thin" },
};

export async function handleManualStoreAuditExport(from, to, setLoading) {
  setLoading(true);
  try {
    const body = { from: parseDatePayload(from), to: parseDatePayload(to) };
    const res  = await apiClient.post("/api/manual-store-audit-report", body);
    if (res.status !== 200) throw new Error("API failed: " + res.status);

    const data = Array.isArray(res.data) ? res.data : [res.data];
    if (!data.length) throw new Error("No data returned from API");

    const ExcelJSModule = await import("exceljs/dist/exceljs.min.js").catch(
      async () => await import("exceljs")
    );
    const ExcelJS = ExcelJSModule.default || ExcelJSModule;
    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet("Manual Store Audit");

  
    const firstRow = data[0] || {};
    const shelfKeyRegex = /^Shelf (\d+) - (.+)$/;
    const nonShelfKeys  = [];
    const shelfSubColsMap = {};

    Object.keys(firstRow).forEach(key => {
      const m = key.match(shelfKeyRegex);
      if (m) {
        const n = parseInt(m[1], 10);
        if (!shelfSubColsMap[n]) shelfSubColsMap[n] = [];
        shelfSubColsMap[n].push(m[2]); 
      } else {
        nonShelfKeys.push(key);
      }
    });

    const shelfNums = Object.keys(shelfSubColsMap).map(Number).sort((a, b) => a - b);

    const subCols = shelfSubColsMap[shelfNums[0]] || [];

    ws.getRow(1).height = 55;
    ws.getRow(2).height = 55;

    let col = 1;

    nonShelfKeys.forEach(key => {
      ws.mergeCells(1, col, 2, col);
      const cell    = ws.getCell(1, col);
      cell.value    = key.replace(/\r\n/g, " ").trim();
      cell.fill     = RED_FILL;
      cell.font     = WHITE_FONT_BOLD;
      cell.alignment = CENTER_WRAP;
      cell.border   = THIN_BORDER;
      ws.getColumn(col).width = 26;
      col++;
    });

   
    shelfNums.forEach(n => {
      const startCol = col;
      const endCol   = col + subCols.length - 1;

      ws.mergeCells(1, startCol, 1, endCol);
      const shelfCell    = ws.getCell(1, startCol);
      shelfCell.value    = `Shelf ${n}`;
      shelfCell.fill     = ORANGE_FILL;
      shelfCell.font     = { bold: true, color: { argb: "FFFFFFFF" }, size: 11 };
      shelfCell.alignment = CENTER_WRAP;
      shelfCell.border   = THIN_BORDER;

      
      subCols.forEach((subCol, i) => {
        const cell    = ws.getCell(2, startCol + i);
        cell.value    = subCol.trim();
        cell.fill     = AMBER_FILL;
        cell.font     = BLACK_FONT_BOLD;
        cell.alignment = CENTER_WRAP;
        cell.border   = THIN_BORDER;
        ws.getColumn(startCol + i).width = 20;
      });

      col = endCol + 1;
    });

   
    data.forEach(row => {
      const vals = [
        
        ...nonShelfKeys.map(k => {
          const v = row[k];
          return v !== undefined && v !== null ? v : "";
        }),
       
        ...shelfNums.flatMap(n =>
          subCols.map(sc => {
            const v = row[`Shelf ${n} - ${sc}`];
            return v !== undefined && v !== null ? v : "";
          })
        ),
      ];

      const dataRow = ws.addRow(vals);
      dataRow.height = 18;
      dataRow.eachCell({ includeEmpty: true }, cell => {
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border    = THIN_BORDER;
      });
    });

  
    ws.views = [{ state: "frozen", ySplit: 2 }];

    const buf = await wb.xlsx.writeBuffer();
    saveAs(
      new Blob([buf], { type: "application/octet-stream" }),
      `manual_store_audit_${from.replace(/-/g, "")}_to_${to.replace(/-/g, "")}.xlsx`
    );
  } catch (err) {
    console.error("Manual Store Audit export error:", err);
    alert("Failed to generate Excel: " + (err.message || err));
  } finally {
    setLoading(false);
  }
}